(function(window, $, psw) {
    'use strict';

    $('.learning-path a').on('click contextmenu', function (e) {

        var link = $(this);
        if(!cookieConsent.analyticsEnabled || link.hasClass('nav-link')) {
            return;
        }

        var href = link.attr('href');
        var hrefText = link.text();
        var source = window.location.pathname.toLowerCase();

        var sendEvt = function (name, value) {
            ga('send', 'event', 'LearningPath', name, value, {
                transport: 'beacon'
            });
        };

        if(window._kmq) {
            _kmq.push(['record', 'Learning Path Link Click', {
                source: source,
                target: href
            }]);
        }

        GA4Event.learningPathClick(hrefText, href);

        if(window.ga && window.ga.create) {
            sendEvt('LinkNav', source + ' => ' + href);
            sendEvt('LinkSource', source);
            sendEvt('LinkTarget', href);
        }
    });

    $('#learning-subscribe-form').submit(function (e) {

        e.preventDefault();

        var component = $('.learning-subscribe');
        var error = component.find('.alert-warning').hide();
        var success = component.find('.alert-success');
        var form = component.find('form');
        var email = $('#learning-subscribe-email').val();

        psw.ajax({
            url: psw.api("/pardot/postall"),
            type: "POST",
            data: {
                "request-email": email,
                url: 'https://go.pardot.com/l/27442/2018-06-13/8dyfsk',
                hash: 'LgnHLMbCYsha9pXL0gtY7tzQPzHEcHmUZaeL6MsWWWM='
            },
            success: function () {
                success.show();
                form.hide();
            },
            error: function () {
                error.show();
            }
        });

    });

}(window, jQuery, psw));
